import { useObligations } from '@/hooks/queries/useFinanceDeadlines';

// The obligation kinds the action queue renders as cards (useActionQueueDescriptors). While one is
// waiting, the close hub must not claim there is nothing to file.
const QUEUED_KINDS = new Set(['RapidNotice', 'DailyAggregate', 'PreSessionAggregate']);

// An unreadable obligations list counts as one waiting: the hub can't vouch that nothing is.
export function useHasQueuedObligation(): boolean {
  const read = useObligations();
  if (read.status === 'failed' || read.status === 'offline') return true;
  if (read.status !== 'ready') return false;
  return read.data.obligations.some((o) => o.isRapidReport || QUEUED_KINDS.has(o.obligationKind));
}
